import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Paper, Title, Stack, Box } from "@mantine/core";
import { FilterForm } from "@/components/filters";
import { filtersApi } from "@/api/client";
import type { Filter } from "@/api/types";

export const Route = createFileRoute("/_authenticated/filters/new")({
  component: NewFilterPage,
});

function NewFilterPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data: Partial<Filter>) =>
      filtersApi.create(data as Omit<Filter, "id" | "created_at">),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["filters"] });
      navigate({ to: "/filters" });
    },
  });

  return (
    <Box maw={900} mx="auto">
      <Stack gap="md">
        <Title order={1}>Create Filter</Title>

        <Paper p="md" radius="md" withBorder style={{ borderColor: "#0f3460" }}>
          <FilterForm
            onSubmit={(data) => createMutation.mutate(data)}
            isSubmitting={createMutation.isPending}
          />
        </Paper>
      </Stack>
    </Box>
  );
}
